export enum EMA_TYPES
{
  SINGLE_EMA = 1,
  DOUBLE_EMA = 2,
  TRIPLE_EMA = 3
}